const Consts = {
  // NOTE: maintain cellSize * boardW and others ratio
  cellSize: 30 / 2,
  boardW: 15 * 2, // width is 450
  boardH: 27 * 2, // visible part // height is 810
  boardHH: 100 * 2, // total height // total height is 3000
};

export default Consts;
